module.exports = __webpack_public_path__ + "static/media/pro.e6ce7840.png";